<script>
    import mwLogo from './images/MW_LR_Landscape_blk.png'

    export let licence = 'Creative Commons Attribution - NonCommercial - No Derivative Works 3.0 New Zealand License (BY-NC-ND)';

    const date = new Date();

    const year = Math.max(2022, date.getFullYear());
</script>

<style>
    .footer {
        display: flex;
        align-items: center;
    }

    .footer > * {
        flex: 1;
    }

    .footer > a {
        display: block;
        max-width: 320px;
        padding: 1em 1em 1em 0;
    }

    .footer > a > img {
        max-width: 100%;
    }

    ul {
        padding-left: 0.5em;
        list-style-position: inside;
    }

    @media (max-width: 500px) {
        .footer {
            display: block;
        }
    }

    @media print {
        h4 {
            break-before: page;
        }
    }
</style>

<h4>About this publication</h4>

<ul>
 <li>This information sheet describes the typical average properties of the specified soil map unit.</li>
 <li>For further information on individual soils, contact <a href="https://www.landcareresearch.co.nz" target="_blank" rel="noopener">Landcare Research New Zealand Ltd</a></li>
 <li>Advice should be sought from soil and land use experts before making decisions on individual farms and paddocks.</li>
 <li>The information has been derived from numerous sources. It may not be complete, correct or up to date.</li>
 <li>This information sheet is licensed by Landcare Research on an "as is" and "as available" basis and without any warranty of any kind, either express or implied.</li>
 <li>Landcare Research shall not be liable on any legal basis (including without limitation negligence) and expressly excludes all liability for loss or damage howsoever and whenever caused to a user of this factsheet.</li> 
</ul>

<div class="footer">
    <a href="https://www.landcareresearch.co.nz" target="_blank" rel="noopener">
        <img src={mwLogo} alt="Manaaki Whenua - Landcare Research"/>
    </a>
    <div class="footer-licence">
        © Landcare Research New Zealand Limited {year}. <br/>
        Licensed under {licence}
    </div>
</div>
